<template>
    <div class="focused-well-left-panel">
        <focused-well-left-panel-top :well="focusedWell" />

        <notes-and-insights :well="focusedWell" />

        <prev-next-well-buttons />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import FocusedWellLeftPanelTop from './FocusedWellLeftPanelTop'
import NotesAndInsights from './partials/NotesAndInsights'
import PrevNextWellButtons from './PrevNextWellButtons'

export default {
    name: 'FocusedWellLeftPanel',
    components: {
        FocusedWellLeftPanelTop,
        NotesAndInsights,
        PrevNextWellButtons
    },
    computed: {
        ...mapState({
            focusedWell: state => state.timelapse.focusedWell
        })
    }
}
</script>

<style lang="scss" scoped>
.focused-well-left-panel {
    display: flex;
    flex-direction: column;
    background-color: $dark-3;

    .notes-and-insights {
        flex-grow: 1;
    }

    @media screen and #{$new-break3} {
        .prev-next-well-buttons {
            position: fixed;
            width: 100%;
            height: $well-video-controls-bottom-panel-height;
            bottom: $well-video-controls-bottom-panel-height;
        }
    }

    @media screen and #{$new-break4close} {
        &:not(.notes_and_insights) {
            .notes-and-insights {
                display: none;
            }
        }
    }

    @media screen and #{$new-break4} {
        &.notes_and_insights {
            display: grid;

            .focused-well-left-panel-top {
                grid-area: summary;
            }
            .notes-and-insights {
                grid-area: notesinsights;
            }

            grid-template-columns: min-content 1fr;
            grid-template-rows: min-content;
            grid-template-areas: 'summary notesinsights';
        }
    }

    @media screen and #{$new-break4open} {
        .prev-next-well-buttons {
            margin-top: auto;
            margin-left: auto;
        }
    }
}
</style>
